import API_BASE from './apiBase';
import { authHeaders } from './authService';
const API_URL = `${API_BASE}/containers/photos/`;

export const fetchImageInfo = async (containerId) => {
  try {
    const response = await fetch(`${API_URL}${encodeURIComponent(containerId)}`, { headers: await authHeaders() });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    let result = await response.json();
    return result.data
  } catch (error) {
    throw new Error(error.message);
  }
};
